export default __webpack_public_path__ + "locales/de/ConnectDialog.json?hash=ae3f3452c0f3d0e8bb77db815754714b";